import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "aria-hidden": "true",
  viewBox: "0 0 32 32",
  fill: "none",
  class: "h-8 w-8 flex-none [--icon-foreground:theme(colors.slate.900)] [--icon-background:theme(colors.white)]"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><radialGradient cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" id=\"callout-gradient\" gradientTransform=\"matrix(0 21 -21 0 20 11)\"><stop stop-color=\"#0EA5E9\"></stop><stop stop-color=\"#22D3EE\" offset=\".527\"></stop><stop stop-color=\"#818CF8\" offset=\"1\"></stop></radialGradient></defs><g><circle cx=\"20\" cy=\"20\" r=\"12\" fill=\"url(#callout-gradient)\"></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 24.995c0-1.855 1.094-3.501 2.427-4.792C24.61 18.087 26 15.07 26 12.231 26 7.133 21.523 3 16 3S6 7.133 6 12.23c0 2.84 1.389 5.857 3.573 7.973C10.906 21.494 12 23.14 12 24.995V27a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2.005Z\" class=\"fill-[var(--icon-background)]\" fill-opacity=\"0.5\"></path><path d=\"M25 12.23c0 2.536-1.254 5.303-3.269 7.255l1.391 1.436c2.354-2.28 3.878-5.547 3.878-8.69h-2ZM16 4c5.047 0 9 3.759 9 8.23h2C27 6.508 21.998 2 16 2v2Zm-9 8.23C7 7.76 10.953 4 16 4V2C10.002 2 5 6.507 5 12.23h2Zm3.269 7.255C8.254 17.533 7 14.766 7 12.23H5c0 3.143 1.523 6.41 3.877 8.69l1.392-1.436ZM13 27v-2.005h-2V27h2Zm1 1a1 1 0 0 1-1-1h-2a3 3 0 0 0 3 3v-2Zm4 0h-4v2h4v-2Zm1-1a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2Zm0-2.005V27h2v-2.005h-2ZM8.877 20.921C10.132 22.136 11 23.538 11 24.995h2c0-2.253-1.32-4.143-2.731-5.51L8.877 20.92Zm12.854-1.436C20.32 20.852 19 22.742 19 24.995h2c0-1.457.869-2.859 2.122-4.074l-1.391-1.436Z\" class=\"fill-[var(--icon-foreground)]\"></path><path d=\"M20 26a1 1 0 1 0 0-2v2Zm-8-2a1 1 0 1 0 0 2v-2Zm2 0h-2v2h2v-2Zm1 1V13.5h-2V25h2Zm-5-11.5v1h2v-1h-2Zm3.5 4.5h5v-2h-5v2Zm8.5-3.5v-1h-2v1h2ZM20 24h-2v2h2v-2Zm-2 0h-4v2h4v-2Zm-1-10.5V25h2V13.5h-2Zm2.5-2.5a2.5 2.5 0 0 0-2.5 2.5h2a.5.5 0 0 1 .5-.5v-2Zm2.5 2.5a2.5 2.5 0 0 0-2.5-2.5v2a.5.5 0 0 1 .5.5h2ZM18.5 18a3.5 3.5 0 0 0 3.5-3.5h-2a1.5 1.5 0 0 1-1.5 1.5v2ZM10 14.5a3.5 3.5 0 0 0 3.5 3.5v-2a1.5 1.5 0 0 1-1.5-1.5h-2Zm2.5-3.5a2.5 2.5 0 0 0-2.5 2.5h2a.5.5 0 0 1 .5-.5v-2Zm2.5 2.5a2.5 2.5 0 0 0-2.5-2.5v2a.5.5 0 0 1 .5.5h2Z\" class=\"fill-[var(--icon-foreground)]\"></path></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]
const _hoisted_5 = {
  key: 1,
  "aria-hidden": "true",
  viewBox: "0 0 32 32",
  fill: "none",
  class: "h-8 w-8 flex-none [--icon-foreground:theme(colors.amber.900)] [--icon-background:theme(colors.amber.100)]"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<defs><radialGradient cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" id=\"callout-gradient\" gradientTransform=\"rotate(65.924 1.519 20.92) scale(25.7391)\"><stop stop-color=\"#FDE68A\" offset=\".08\"></stop><stop stop-color=\"#F59E0B\" offset=\".837\"></stop></radialGradient></defs><g><circle cx=\"20\" cy=\"20\" r=\"12\" fill=\"url(#callout-gradient)\"></circle><path d=\"M3 16c0 7.18 5.82 13 13 13s13-5.82 13-13S23.18 3 16 3 3 8.82 3 16Z\" fill-opacity=\"0.5\" class=\"fill-[var(--icon-background)] stroke-[color:var(--icon-foreground)]\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"m15.408 16.509-1.04-5.543a1.66 1.66 0 1 1 3.263 0l-1.039 5.543a.602.602 0 0 1-1.184 0Z\" class=\"fill-[var(--icon-foreground)] stroke-[color:var(--icon-foreground)]\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 23a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z\" fill-opacity=\"0.5\" stroke=\"currentColor\" class=\"fill-[var(--icon-background)] stroke-[color:var(--icon-foreground)]\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g>", 2)
const _hoisted_8 = [
  _hoisted_6
]
const _hoisted_9 = { class: "ml-4 flex-auto min-w-[1px]" }

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalloutComponent',
  props: {
  icon: {
    type: String as PropType<'info' | 'warning'>,
    required: true,
  },
  heading: {
    type: String as PropType<'h2' | 'h3' | 'h4'>,
    default: 'h2',
  },
  title: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;

const styles = {
  info: {
    container: 'bg-sky-50',
    title: 'text-sky-900',
    body: 'text-sky-800 [--tw-prose-background:theme(colors.sky.50)] prose-a:text-sky-900 prose-code:text-sky-900',
  },
  warning: {
    container: 'bg-amber-50',
    title: 'text-amber-900',
    body: 'text-amber-800 [--tw-prose-underline:theme(colors.amber.400)] [--tw-prose-background:theme(colors.amber.50)] prose-a:text-amber-900 prose-code:text-amber-900',
  },
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["my-8 flex rounded-3xl p-6", styles[__props.icon].container])
  }, [
    (__props.icon === 'info')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
      : (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_8)),
    _createElementVNode("div", _hoisted_9, [
      (__props.title)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.heading), {
            key: 0,
            class: _normalizeClass(["ignore-toc m-0 mb-2.5 font-display text-xl font-semibold leading-8", styles[__props.icon].title])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["prose", styles[__props.icon].body])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ])
  ], 2))
}
}

})